module.exports = __webpack_public_path__ + "Roboto-Bold.e31fcf1885e371e19f57.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Bold.ttf
// module id = ../../../../../font/roboto/Roboto-Bold.ttf
// module chunks = styles